<template>
  <v-card class="network-card" @click="navigateToNetworkPage(network)" @mouseenter="hovered = true"
          @mouseleave="hovered = false">
    <v-img @error="imageUrl = (sizeFormattedImageUrl(network.fallbackImageURL, 500, 700))"
           :src="imageUrl"
           height="100%" width="100%"/>
    <div v-if="hovered" class="network-card__overlay">
      <span class="network-card__visit-link">{{ NetworkConstants.VISIT_NOW }}</span>
    </div>
    <v-card-title class="network-card__card-title">{{ network.title }}</v-card-title>
  </v-card>
</template>

<script>
import { NetworkConstants } from "./NetworkConstants";
import { routerNames } from "@/components/appCommon.constants";
import { imageErrorFallback } from "../../common/utils/utils";
import { storeGetters } from '@/store/storeGetters.constant';
import { mapGetters } from 'vuex';
import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

export default {
  props: {
    network: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imageErrorFallback,
      NetworkConstants,
      hovered: false,
      sizeFormattedImageUrl,
      imageUrl: "",
    };
  },
  created() {
    this.imageUrl = this.network.imageUrl ? sizeFormattedImageUrl(this.network.imageUrl, 500, 700) : "";
  },
  methods: {
    navigateToNetworkPage(network) {
      if (network.communityType !== NetworkConstants.COMMUNITIES) {
        this.$router.push(`/${routerNames.NETWORK_LANDING_PAGE}/${network.communityId}`);
      } else {
        this.$router.push(`/${network.recordTypeName}/${network.communityId}`);
      }
    },
  },
  computed: {
    ...mapGetters({
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
    }),
  },
};

</script>
<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.network-card {
  height: 210px;
  width: 300px;
  margin: 20px;
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  cursor: pointer;
  @include breakpoint(xs) {
    height: 220px;
    width: 340px;
  }

  &:hover {
    .network-card__overlay {
      background-color: $ypo-network-card-background;
      opacity: 1;
    }
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: background-color 0.3s ease-in-out;
  }

  &__visit-link {
    color: $black;
    font-weight: bold;
  }

  &__card-title {
    background-color: $ypo_blue;
    color: white;
    font-size: 16px;
    margin-bottom: 10px;
    border-radius: 12px !important;
    padding: 8px;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    z-index: 2;
  }
}
</style>
